import React, { useEffect, useMemo, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import content from "../../../helper/content/signup.json";
import WebInput from "../../../component/library/webInput";
import WebButton from "../../../component/library/webButton";
import WebOtpInput from "../../../component/library/webOtpInput";
import { useLoader } from "../../../base/context/LoaderProvider";
import { ToastTypes, useMessage } from "../../../base/context/MessageProvider";
import { useNavigate, useLocation } from "react-router-dom"; 
import { emailRegex, gstRegex, phoneFirstLetter } from "../../../helper/regex";
import { AuthApiService } from "../../../service/authApiService";
import { AffiliateApiService } from "../../../service/affiliateApiService";
import {
  getAuthVerifiedData,
  setAuthVerifiedData,
} from "../../../storage/localStorage";
import { useDispatch } from "react-redux";
import { addItems } from "../../../redux/slices/sidebarSlice";
import { adminSidebarArray, sellerSidebarArray } from "../../../helper/utils";
import { setAuthLocalStorage } from "../../../storage/localStorage";

import SignUpImage from "../../../assets/images/signup/signup.png";
import WebNavbar from '../../../website/component/layout/navbar';
import "../login/style.css";
import "./style.css";
import ErrorModal from "../../../component/library/errorModal";

export default function Signup() {
  const navigate = useNavigate();
  const message = useMessage();
  const loader = useLoader();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const location = useLocation(); 
  const [errorModal, setErrorModal] = useState({ isOpen: false, message: "" });

  const showErrorModal = (msg) => {
    const m = String(msg || "").trim();
    if (!m) return;
    setErrorModal({ isOpen: true, message: m });
  };

  const closeErrorModal = () => setErrorModal({ isOpen: false, message: "" });
  const [emailOtpUI, setEmailOtpUI] = useState({
    sent: false,
    verified: false,
    timerOn: false,
    seconds: 60,
  });
  const [emailOtp, setEmailOtp] = useState("");

  const [isSendingEmailOtp, setIsSendingEmailOtp] = useState(false);
  const [isVerifyingEmailOtp, setIsVerifyingEmailOtp] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [phoneOtpUI, setPhoneOtpUI] = useState({
    sent: false,
    verified: false,
    timerOn: false,
    seconds: 60,
  });
  const [phoneOtp, setPhoneOtp] = useState("");
  const [isSendingPhoneOtp, setIsSendingPhoneOtp] = useState(false);
  const [isVerifyingPhoneOtp, setIsVerifyingPhoneOtp] = useState(false);

  const [phoneVerified, setPhoneVerified] = useState(false);
  // const [otpSend, setOtpSend] = useState(false);
  // const [timer, setTimer] = useState(false);
  // const [time, setTime] = useState(60);
  const [otp, setOtp] = useState("");
  
  // Referral tracking state
  const [refFromUrl, setRefFromUrl] = useState("");
  const [referralTracked, setReferralTracked] = useState(false);

  // Affiliate program: from URL ?affiliate=1
  const isAffiliateFlow = useMemo(() => {
    const params = new URLSearchParams(location?.search || "");
    return params.get("affiliate") === "1";
  }, [location?.search]);
  const [existingUserForAffiliate, setExistingUserForAffiliate] = useState(false);
  const [showNetworkModal, setShowNetworkModal] = useState(false);
  const [affiliateNetworks, setAffiliateNetworks] = useState({ facebook: "", instagram: "", youtube: "" });
  const [isSavingNetworks, setIsSavingNetworks] = useState(false);
  const [affiliateDoneAfterSignup, setAffiliateDoneAfterSignup] = useState(false);
  const [fetchingProfileForAffiliate, setFetchingProfileForAffiliate] = useState(false);
  const [showAffiliateChartModal, setShowAffiliateChartModal] = useState(false);
  const [affiliateProgramDisplay, setAffiliateProgramDisplay] = useState(null);

  useEffect(() => {
    if (!isAffiliateFlow) return;
    AffiliateApiService.getProgramDisplay()
      .then((res) => {
        if (res?.status?.code === 200 && res?.data) setAffiliateProgramDisplay(res.data);
      })
      .catch(() => {});
  }, [isAffiliateFlow]);

  const SALES_OPTIONS = useMemo(
    () => [
      "Shopify",
      "Amazon",
      "Flipkart",
      "Messho",
      "India Mart",
      "First cry",
      "myntra",
      "Facebook",
      "Instagram",
      "Whatsapp",
      "Wordpress",
      "open cart",
      "Other",
    ],
    []
  );

  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    companyName: "",
    address1: "",
    address2: "",
    state: "",
    city: "",
    zipcode: "",
    gst: "",
    password: "",
    confirmPassword: "",
    marketPlaces: [],
    acceptTnc: false,
    referredBy: "", 
  });

  const [error, setError] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    companyName: "",
    address1: "",
    address2: "",
    state: "",
    city: "",
    zipcode: "",
    gst: "",
    password: "",
    confirmPassword: "",
    marketPlaces: "",
    acceptTnc: "",
    emailOtp: "",
    phoneOtp: "",
  });

  const [salesOpen, setSalesOpen] = useState(false);
  const [salesQuery, setSalesQuery] = useState("");


  // set sidebar items based on role
  const handleUpdateSidebar = (type) => {
    if (type === "seller") {
      dispatch(addItems(sellerSidebarArray));
    } else if (type === "admin") {
      dispatch(addItems(adminSidebarArray));
    }
  };
  const getRedirectTarget = () => {
    const fromState = location?.state?.from;
    const from =
      (fromState &&
        `${fromState.pathname || ""}${fromState.search || ""}${fromState.hash || ""}`) ||
      null;
    const fromSS = sessionStorage.getItem("postAuthRedirect");
    const target = from || fromSS || "";
    if (!target || target.startsWith("/login") || target.startsWith("/signup")) return null;
    return target;
  };
  const goAfterAuth = (roleFallback) => {
    const to = getRedirectTarget();
    sessionStorage.removeItem("postAuthRedirect");
    if (to) return navigate(to, { replace: true });
    if (roleFallback === "seller") return navigate("/", { replace: true });
    if (roleFallback === "admin" || roleFallback === "sub-admin") return navigate("/admin/dashboard", { replace: true });
    return navigate("/", { replace: true });
  };

  // Extract referral code from URL (supports both hash and query params)
  // Examples: 
  //   - /signup#utm_medium=thefounderdream
  //   - /signup?ref=thefounderdream
  //   - /signup#thefounderdream
  useEffect(() => {
    let refCode = null;
    let utmParams = {};
    
    // First check query parameters (e.g., ?ref=code)
    const searchParams = new URLSearchParams(window.location.search);
    refCode = searchParams.get('ref') || 
              searchParams.get('referral') ||
              searchParams.get('utm_medium') ||
              searchParams.get('utm_source') ||
              searchParams.get('utm_campaign');
    
    if (searchParams.get('utm_source')) utmParams.utmSource = searchParams.get('utm_source');
    if (searchParams.get('utm_medium')) utmParams.utmMedium = searchParams.get('utm_medium');
    if (searchParams.get('utm_campaign')) utmParams.utmCampaign = searchParams.get('utm_campaign');
    if (searchParams.get('utm_term')) utmParams.utmTerm = searchParams.get('utm_term');
    if (searchParams.get('utm_content')) utmParams.utmContent = searchParams.get('utm_content');
    
    // If not found in query, check hash (e.g., #utm_medium=code or #code)
    if (!refCode) {
      const hash = window.location.hash;
      if (hash) {
        const hashParams = new URLSearchParams(hash.substring(1));
        
        refCode = hashParams.get('utm_medium') || 
                  hashParams.get('ref') || 
                  hashParams.get('referral') ||
                  hashParams.get('utm_source') ||
                  hashParams.get('utm_campaign');
        
        // If hash is just a simple value like #thefounderdream (no = sign)
        if (!refCode && hash.length > 1 && !hash.includes('=')) {
          refCode = hash.substring(1);
        }
        
        // Get UTM params from hash if not already set
        if (!utmParams.utmSource && hashParams.get('utm_source')) utmParams.utmSource = hashParams.get('utm_source');
        if (!utmParams.utmMedium && hashParams.get('utm_medium')) utmParams.utmMedium = hashParams.get('utm_medium');
        if (!utmParams.utmCampaign && hashParams.get('utm_campaign')) utmParams.utmCampaign = hashParams.get('utm_campaign');
        if (!utmParams.utmTerm && hashParams.get('utm_term')) utmParams.utmTerm = hashParams.get('utm_term');
        if (!utmParams.utmContent && hashParams.get('utm_content')) utmParams.utmContent = hashParams.get('utm_content');
      }
    }
    
    if (refCode) {
      setRefFromUrl(refCode);
      setData(prev => ({ ...prev, referredBy: refCode }));
      
      // Track the referral visit
      if (!referralTracked) {
        trackReferralVisit(refCode, utmParams);
      }
    }
  }, [referralTracked]);

  // Track referral visit API call
  const trackReferralVisit = async (refCode, utmParams = {}) => {
    try {
      const API_URL = process.env.REACT_APP_APIUrl || 'https://api.importerr.com/api/';
      const response = await fetch(`${API_URL}user/referral/track-visit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          refCode,
          fullUrl: window.location.href,
          utmSource: utmParams.utmSource || '',
          utmMedium: utmParams.utmMedium || '',
          utmCampaign: utmParams.utmCampaign || '',
          utmTerm: utmParams.utmTerm || '',
          utmContent: utmParams.utmContent || '',
        }),
      });
      if (response.ok) {
        setReferralTracked(true);
        console.log('[Referral] Visit tracked successfully');
      }
    } catch (err) {
      console.error('[Referral] Failed to track visit:', err);
    }
  };


  const filteredSales = useMemo(
    () =>
      SALES_OPTIONS.filter((o) =>
        o.toLowerCase().includes(salesQuery.toLowerCase())
      ),
    [SALES_OPTIONS, salesQuery]
  );

  // ---------- helpers ----------
  const resetErrors = (name) => setError((prev) => ({ ...prev, [name]: "" }));

  const handleOnchange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name !== "phone") {
      setData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
      resetErrors(name);
    }
  };

  const handlePhone = (e) => {
    const v = (e.target.value || "").replace(/\D/g, "").slice(0, 10);
    setData((prev) => ({ ...prev, phone: v }));
    resetErrors("phone");
    if (phoneOtpUI.sent || phoneOtpUI.verified) {
      setPhoneOtpUI({ sent: false, verified: false, timerOn: false, seconds: 60 });
      setPhoneOtp("");
      setPhoneVerified(false);
    }
  };

  const toggleSales = (opt) => {
    setData((prev) => {
      const exists = prev.marketPlaces.includes(opt);
      const next = exists
        ? prev.marketPlaces.filter((s) => s !== opt)
        : [...prev.marketPlaces, opt];
      return { ...prev, marketPlaces: next };
    });
    resetErrors("marketPlaces");
  };
  // const setEmailToLocal = () => {
  //   let obj = { email: data.email, phone: data.phone };
  //   setAuthVerifiedData(obj);
  // };

  // const SendVerificationLinktoEmail = () => {
  //   loader.showLoading(true);
  //   const data = { email: getAuthVerifiedData().verifiedEmail };
  //   AuthApiService.verifyEmail(JSON.stringify(data))
  //     .then((res) => {
  //       loader.showLoading(false);
  //       if (res.status.code === 200) {
  //         message.showToast(res.status.message, ToastTypes.SUCCESS);
  //         navigate("/getUserDetails");
  //       } else {
  //         message.showToast(res.error.message, ToastTypes.ERROR);
  //       }
  //     })
  //     .catch(() => {
  //       message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
  //       loader.showLoading(false);
  //     });
  // };

  // const handlePhone = (e) => {
  //   if (!phoneVerified) {
  //     setData({ ...data, phone: e.target.value.slice(0, 10) });
  //     setError({ ...error, phone: "" });
  //     if (otpSend) { setOtpSend(false); setTimer(false); }
  //   }
  //   const v = (e.target.value || "").replace(/\D/g, "").slice(0, 10);
  //   setData((prev) => ({ ...prev, phone: v }));
  //   resetErrors("phone");
  // };


  //   useEffect(() => {
  //     if (timer) {
  //       if (time > 0) {
  //         setTimeout(() => {
  //           setTime(time - 1);
  //         }, 1000);
  //       } else {
  //         setTimer(false);
  //         setTime(60);
  //       }
  //     } else {
  //       setTime(60);
  //     }
  //   }, [time, timer]);

  // --- SEND OTP TO PHONE  ---
  // const sendOtptoPhone = async (e) => {
  //   e.preventDefault();
  //   if (!validatePhone()) return;

  //   loader.showLoading(true);
  //   try {
  //     const payload = { phone: data.phone };
  //     const res = await AuthApiService.sendOtp(JSON.stringify(payload));
  //     loader.showLoading(false);

  //     if (res.status.code === 200) {
  //       message.showToast(res.status.message, ToastTypes.SUCCESS);
  //       setTimer(true);
  //       setOtpSend(true);
  //       setError((prev) => ({ ...prev, phone: "" }));
  //     } else {
  //       message.showToast(res.error.message, ToastTypes.ERROR);
  //     }
  //   } catch {
  //     loader.showLoading(false);
  //     message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
  //   }
  // };

  // --- VERIFY PHONE OTP  ---
  // const handleVerifyOtp = async () => {
  //   loader.showLoading(true);
  //   try {
  //     const otpPayload = { phone: data.phone, otp };
  //     const res = await AuthApiService.verifyOtp(JSON.stringify(otpPayload));
  //     loader.showLoading(false);

  //     if (res.status.code === 200) {
  //       message.showToast(res.status.message, ToastTypes.SUCCESS);
  //       await setPhoneToLocal();
  //       setPhoneVerified(true);
  //       setError((prev) => ({ ...prev, phone: "" }));
  //       setTimer(false);
  //     } else {
  //       message.showToast(res.error.message, ToastTypes.ERROR);
  //     }
  //   } catch {
  //     loader.showLoading(false);
  //     message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
  //   }
  // };


  //   const setPhoneToLocal = () => {
  //     let localData = {
  //       phone: data.phone,
  //     };
  //     setAuthVerifiedData(localData);
  //   };

  //   useEffect(() => {
  //     if (otp.length === 6 && !phoneVerified) {
  //       handleVerifyOtp();
  //     }
  //   }, [otp]);



  // --- PHONE VALIDATION  ---
  // const validatePhone = () => {
  //   let result = true;

  //   if (!data.phone.length) {
  //     setError((prev) => ({ ...prev, phone: "Phone is required" }));
  //     result = false;
  //   } else if (data.phone.length !== 10) {
  //     setError((prev) => ({ ...prev, phone: "Not a valid phone number" }));
  //     result = false;
  //   } else if (data.phone.length === 10) {
  //     const firstLetter = data.phone.slice(0, 1);
  //     if (!phoneFirstLetter.some((num) => num === firstLetter)) {
  //       setError((prev) => ({ ...prev, phone: "Not a valid phone number" }));
  //       result = false;
  //     }
  //   }

  //   return result;
  // };


  // ---------- PIN auto-fill ----------
  const fetchPincodeDetails = async (pin) => {
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
      const j = await res.json();
      if (Array.isArray(j) && j[0]?.Status === "Success") {
        const office = j[0]?.PostOffice?.[0];
        if (office) {
          setData((prev) => ({
            ...prev,
            state: prev.state || office.State || "",
            city: prev.city || office.District || "",
          }));
        }
      } else {
        setError((prev) => ({ ...prev, zipcode: "Invalid PIN code" }));
      }
    } catch { }
  };

  const handleZipChange = (e) => {
    const v = (e.target.value || "").replace(/\D/g, "").slice(0, 6);
    setData((prev) => ({ ...prev, zipcode: v }));
    resetErrors("zipcode");
    if (v.length === 6) fetchPincodeDetails(v);
  };

  // 1) Clear company name if GST is cleared
  useEffect(() => {
    if (!data.gst) {
      setData((p) => ({ ...p, companyName: "" }));
      setError((p) => ({ ...p, companyName: "" }));
    }
  }, [data.gst]);

  useEffect(() => {
    if (emailOtp && error.emailOtp) {
      resetErrors("emailOtp");
    }
  }, [emailOtp]);

  useEffect(() => {
    if (phoneOtp && error.phoneOtp) {
      resetErrors("phoneOtp");
    }
  }, [phoneOtp]);


  // ---------- email OTP ----------
  useEffect(() => {
    let id;
    if (emailOtpUI.timerOn && emailOtpUI.seconds > 0) {
      id = setTimeout(
        () =>
          setEmailOtpUI((p) => ({ ...p, seconds: Math.max(p.seconds - 1, 0) })),
        1000
      );
    }
    if (emailOtpUI.timerOn && emailOtpUI.seconds === 0) {
      setEmailOtpUI((p) => ({ ...p, timerOn: false, seconds: 60 }));
    }
    return () => clearTimeout(id);
  }, [emailOtpUI.timerOn, emailOtpUI.seconds]);

  // ---------- phone OTP timer ----------
  useEffect(() => {
    let id;
    if (phoneOtpUI.timerOn && phoneOtpUI.seconds > 0) {
      id = setTimeout(
        () => setPhoneOtpUI((p) => ({ ...p, seconds: Math.max(p.seconds - 1, 0) })),
        1000
      );
    }
    if (phoneOtpUI.timerOn && phoneOtpUI.seconds === 0) {
      setPhoneOtpUI((p) => ({ ...p, timerOn: false, seconds: 60 }));
    }
    return () => clearTimeout(id);
  }, [phoneOtpUI.timerOn, phoneOtpUI.seconds]);

  const requestEmailOtp = async () => {
    if (!data.email) {
      setError((prev) => ({ ...prev, email: "Email is required" }));
      return;
    }
    if (!emailRegex.test(data.email)) {
      setError((prev) => ({ ...prev, email: "Not a valid email address" }));
      return;
    }
    setIsSendingEmailOtp(true);
    loader.showLoading(true);
    try {
      const payload = { email: data.email ? data.email.toLowerCase().trim() : data.email };
      const res = await AuthApiService.sendEmailOtp(JSON.stringify(payload));
      loader.showLoading(false);
      if (res.status.code === 200) {
        message.showToast(res.status.message, ToastTypes.SUCCESS);
        setEmailOtpUI((p) => ({ ...p, sent: true, timerOn: true }));
      } else {
        const msg = res.error?.message || "Failed to send OTP";
        setError((prev) => ({
          ...prev,
          email: msg,
          emailOtp: "",
        }));
        setEmailOtpUI({ sent: false, verified: false, timerOn: false, seconds: 60 });
        setEmailOtp("");
        // showErrorModal(msg);
      }
    } catch (err) {
      loader.showLoading(false);
      const msg = err?.message || "Server error. Try again later";
      setError((prev) => ({ ...prev, email: msg, emailOtp: "" }));
      setEmailOtpUI({ sent: false, verified: false, timerOn: false, seconds: 60 });
      setEmailOtp("");
      // showErrorModal(msg);
    } finally {
      setIsSendingEmailOtp(false);
    }
  };

  const verifyEmailOtp = async () => {
    if (!emailOtp || emailOtp.length !== 6) {
      setError((prev) => ({ ...prev, emailOtp: "Enter 6-digit OTP" }));
      return;
    }
    setIsVerifyingEmailOtp(true);
    loader.showLoading(true);
    try {
      const payload = { email: data.email ? data.email.toLowerCase().trim() : data.email, otp: emailOtp };
      const res = await AuthApiService.verifyEmailOtp(JSON.stringify(payload));
      loader.showLoading(false);
      if (res.status.code === 200) {
        setEmailOtpUI({ sent: true, verified: true, timerOn: false, seconds: 60 });
        message.showToast("Email verified", ToastTypes.SUCCESS);
        setError((prev) => ({ ...prev, emailOtp: "" }));

        if (isAffiliateFlow) {
          setFetchingProfileForAffiliate(true);
          try {
            const checkRes = await AuthApiService.checkEmailForAffiliate(
              JSON.stringify({ email: data.email ? data.email.toLowerCase().trim() : data.email })
            );
            if (checkRes.status?.code === 200 && checkRes.data?.exists && checkRes.data?.user) {
              const u = checkRes.data.user;
              setData((prev) => ({
                ...prev,
                firstName: u.firstName || prev.firstName,
                lastName: u.lastName || prev.lastName,
                phone: u.phone || prev.phone,
                companyName: u.companyName || prev.companyName,
                address1: u.address1 || prev.address1,
                address2: u.address2 || prev.address2,
                state: u.state || prev.state,
                city: u.city || prev.city,
                zipcode: u.zipcode || prev.zipcode,
                gst: u.gst || prev.gst,
                marketPlaces: Array.isArray(u.marketPlaces) ? u.marketPlaces : prev.marketPlaces,
              }));
              setExistingUserForAffiliate(true);
              message.showToast("We found your account. Review details and click Become Affiliate.", ToastTypes.SUCCESS);
            }
          } catch (_) {
            // ignore; user may be new
          } finally {
            setFetchingProfileForAffiliate(false);
          }
        }
      } else {
        message.showToast(res.error.message, ToastTypes.ERROR);
        setError((prev) => ({ ...prev, emailOtp: res.error.message }));
      }
    } catch (err) {
      loader.showLoading(false);
      message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
      setError((prev) => ({ ...prev, emailOtp: err?.message || "Server error. Try again later" }));
    } finally {
      setIsVerifyingEmailOtp(false);
    }
  };

  // ---------- phone OTP ----------
  const requestPhoneOtp = async () => {
    if (!data.firstName || !data.firstName.trim()) {
      setError((prev) => ({ ...prev, firstName: "First name is required" }));
      return;
    }
    if (!data.phone) {
      setError((prev) => ({ ...prev, phone: "Contact Number is required" }));
      return;
    }
    if (data.phone.length !== 10 || !phoneFirstLetter.includes(data.phone[0])) {
      setError((prev) => ({ ...prev, phone: "Not a valid phone number" }));
      return;
    }
    setIsSendingPhoneOtp(true);
    loader.showLoading(true);
    try {
      const payload = { phone: data.phone, firstName: data.firstName.trim() };
      const res = await AuthApiService.sendPhoneOtp(JSON.stringify(payload));
      loader.showLoading(false);
      if (res.status.code === 200) {
        message.showToast(res.status.message, ToastTypes.SUCCESS);
        setPhoneOtpUI((p) => ({ ...p, sent: true, timerOn: true }));
        setPhoneVerified(false);
      } else {
        const msg = res.error?.message || "Failed to send mobile OTP";
        // showErrorModal(msg);
        if (/first name/i.test(msg)) {
          setError((prev) => ({ ...prev, firstName: msg }));
        } else if (/phone/i.test(msg)) {
          setError((prev) => ({ ...prev, phone: msg, phoneOtp: "" }));
        } else {
          setError((prev) => ({ ...prev, phoneOtp: msg }));
        }
        setPhoneOtpUI((p) => ({ ...p, sent: false, verified: false, timerOn: false, seconds: 60 }));
        setPhoneVerified(false);
      }
    } catch (err) {
      loader.showLoading(false);
      const msg = err?.message || "Server error. Try again later";
      // showErrorModal(msg);
      setError((prev) => ({ ...prev, phoneOtp: msg, phone: msg }));
      setPhoneOtpUI((p) => ({ ...p, sent: false, verified: false, timerOn: false, seconds: 60 }));
      setPhoneVerified(false);
    } finally {
      setIsSendingPhoneOtp(false);
    }
  };

  const verifyPhoneOtpHandler = async () => {
    if (!phoneOtp || phoneOtp.length !== 6) {
      setError((prev) => ({ ...prev, phoneOtp: "Enter 6-digit OTP" }));
      return;
    }
    setIsVerifyingPhoneOtp(true);
    loader.showLoading(true);
    try {
      const payload = { phone: data.phone, otp: phoneOtp };
      const res = await AuthApiService.verifyPhoneOtp(JSON.stringify(payload));
      loader.showLoading(false);
      if (res.status.code === 200) {
        setPhoneOtpUI({ sent: true, verified: true, timerOn: false, seconds: 60 });
        setPhoneVerified(true);
        message.showToast("Mobile number verified", ToastTypes.SUCCESS);
        setError((prev) => ({ ...prev, phoneOtp: "", phone: "" }));
      } else {
        const msg = res.error?.message || "Mobile OTP verification failed";
        setError((prev) => ({ ...prev, phoneOtp: msg }));
        // showErrorModal(msg);
      }
    } catch (err) {
      loader.showLoading(false);
      const msg = err?.message || "Server error. Try again later";
      setError((prev) => ({ ...prev, phoneOtp: msg }));
      // showErrorModal(msg);
    } finally {
      setIsVerifyingPhoneOtp(false);
    }
  };

  // ---------- validation ----------
  const validate = () => {
    let ok = true;
    const set = (k, v) => {
      ok = false;
      setError((prev) => ({ ...prev, [k]: v }));
    };

    const isAffiliateNewUser = isAffiliateFlow && !existingUserForAffiliate;

    if (!data.firstName) set("firstName", "First name is required");
    else if (!data.lastName) set("lastName", "Last name is required");
    else if (!isAffiliateNewUser) {
      if (!data.phone) set("phone", "Contact Number is required");
      else if (data.phone.length !== 10 || !phoneFirstLetter.includes(data.phone[0]))
        set("phone", "Not a valid phone number");
      else if (!phoneOtpUI.verified) set("phoneOtp", "Please verify your mobile number");
    }
    if (!data.email) set("email", "Email is required");
    else if (!emailRegex.test(data.email)) set("email", "Not a valid email address");
    else if (!emailOtpUI.verified) set("emailOtp", "Please verify your email");
    else if (data.gst && !gstRegex.test(data.gst)) set("gst", "Not a valid GST number");
    else if (!existingUserForAffiliate) {
      if (!data.password) set("password", "Password is required");
      else if (!data.confirmPassword) set("confirmPassword", "Password is required");
      else if (data.password !== data.confirmPassword) set("confirmPassword", "Password not matched");
    }
    if (!data.acceptTnc) set("acceptTnc", "Please accept Terms & Conditions");
    else if (data.gst && !data.companyName && !isAffiliateNewUser) set("companyName", "Company name is required");

    if (ok && data.companyName && !isAffiliateNewUser) {
      if (data.zipcode && data.zipcode.length > 0 && data.zipcode.length !== 6) {
        set("zipcode", "Enter 6-digit PIN code");
      }
    }
    return ok;
  };

  const validateForExistingAffiliate = () => {
    let ok = true;
    const set = (k, v) => {
      ok = false;
      setError((prev) => ({ ...prev, [k]: v }));
    };
    if (!data.firstName) set("firstName", "First name is required");
    else if (!data.lastName) set("lastName", "Last name is required");
    else if (!data.phone) set("phone", "Contact Number is required");
    else if (data.phone.length !== 10 || !phoneFirstLetter.includes(data.phone[0]))
      set("phone", "Not a valid phone number");
    else if (!data.acceptTnc) set("acceptTnc", "Please accept Terms & Conditions");
    return ok;
  };

  const handleBecomeAffiliateClick = (e) => {
    e.preventDefault();
    if (!validateForExistingAffiliate()) return;
    setShowNetworkModal(true);
  };

  const handleSaveNetworks = async () => {
    setIsSavingNetworks(true);
    loader.showLoading(true);
    try {
      if (existingUserForAffiliate) {
        const res = await AuthApiService.becomeAffiliate(
          JSON.stringify({
            email: data.email ? data.email.toLowerCase().trim() : data.email,
            facebook: affiliateNetworks.facebook || "",
            instagram: affiliateNetworks.instagram || "",
            youtube: affiliateNetworks.youtube || "",
          })
        );
        loader.showLoading(false);
        if (res.status?.code === 200) {
          message.showToast("You are now an affiliate!", ToastTypes.SUCCESS);
          setShowNetworkModal(false);
          navigate("/login", { replace: true });
        } else {
          message.showToast(res.error?.message || "Something went wrong", ToastTypes.ERROR);
        }
      } else {
        const res = await AuthApiService.updateAffiliateNetworks(
          JSON.stringify({
            facebook: affiliateNetworks.facebook || "",
            instagram: affiliateNetworks.instagram || "",
            youtube: affiliateNetworks.youtube || "",
          })
        );
        loader.showLoading(false);
        if (res.status?.code === 200) {
          message.showToast("Networks saved.", ToastTypes.SUCCESS);
          setShowNetworkModal(false);
          goAfterAuth("seller");
        } else {
          message.showToast(res.error?.message || "Something went wrong", ToastTypes.ERROR);
        }
      }
    } catch (err) {
      loader.showLoading(false);
      message.showToast(err?.message || "Failed to save", ToastTypes.ERROR);
    } finally {
      setIsSavingNetworks(false);
    }
  };


  //   const handleSignup = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   if (validate()) {
  //     loader.showLoading(true);
  //     AuthApiService.registration(JSON.stringify(data))
  //       .then(async (res) => {
  //         loader.showLoading(false);
  //         if (res.status.code === 200) {
  //           message.showToast(res.status.message, ToastTypes.SUCCESS);
  //           await setEmailToLocal();
  //           await SendVerificationLinktoEmail();
  //         } else {
  //           message.showToast(res.error.message, ToastTypes.ERROR);
  //         }
  //       })
  //       .catch(() => {
  //         message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
  //         loader.showLoading(false);
  //       });
  //   }
  // };


  // ---------- submit ----------


  const handleSignup = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!validate()) return;

    setIsSubmitting(true);
    loader.showLoading(true);
    try {
      const payload = {
        firstName: data.firstName,
        lastName: data.lastName,
        phone: isAffiliateFlow && !existingUserForAffiliate ? (data.phone || "") : data.phone,
        email: data.email ? data.email.toLowerCase().trim() : data.email,
        companyName: data.companyName || "",
        gst: data.gst || "",
        password: data.password,
        marketPlaces: data.marketPlaces || [],
        referredBy: data.referredBy || "",
      };
      if (isAffiliateFlow) payload.affiliateSignup = true;

      const res = await AuthApiService.registration(JSON.stringify(payload));
      loader.showLoading(false);

      if (res.status.code === 200) {
        message.showToast(res.status.message, ToastTypes.SUCCESS);
        // navigate("/login");


        // Try to use signup response; otherwise fall back to logging in once.
        const email = data.email ? data.email.toLowerCase().trim() : data.email;
        const password = data.password;
        let token = res?.data?.token;
        let role = res?.data?.role;

        if (!token || !role) {
          const loginRes = await AuthApiService.login(
            JSON.stringify({ email, password })
          );
          if (loginRes.status.code === 200) {
            token = loginRes.data.token;
            role = loginRes.data.role;
          } else {
            // If auto-login fails, send to login as a fallback
            navigate("/login", { replace: true });
            return;
          }
        }

        await handleUpdateSidebar(role);
        setAuthLocalStorage({ loginHeader: token, userType: role, isAffiliate: isAffiliateFlow });

        if (isAffiliateFlow) {
          setAffiliateDoneAfterSignup(true);
          setShowNetworkModal(true);
          return;
        }
        goAfterAuth(role);
      } else {
        message.showToast(res.error.message, ToastTypes.ERROR);
      }
    } catch (err) {
      loader.showLoading(false);
      message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Follow us section component to avoid code duplication
  const FollowUsSection = () => (
    <div className="follow_us_section">
      <p className="follow_us_text">Follow us on</p>
      <div className="social_icons">
        <a 
          href="https://www.instagram.com/importerr_" 
          target="_blank" 
          rel="noopener noreferrer"
          className="social_icon instagram"
          aria-label="Instagram"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
          </svg>
        </a>
        <a 
          href="https://www.facebook.com/importerr?rdid=lVbyMNlzXUhliunD&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1HyMzEXfe6%2F#"
          target="_blank" 
          rel="noopener noreferrer"
          className="social_icon facebook"
          aria-label="Facebook"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
          </svg>
        </a>
        <a 
          href="https://www.linkedin.com/company/importerr/"
          target="_blank" 
          rel="noopener noreferrer"
          className="social_icon linkedin"
          aria-label="LinkedIn"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
          </svg>
        </a>
      </div>
    </div>
  );

  return (
    <div>
      {/* <Navbar /> */}
      <WebNavbar authPage={true} />
      <div className="auth_container signup_auth_container">
        <div className="auth_row">
          <div className="auth_col_one">
            {isAffiliateFlow && (
              <button
                type="button"
                className="about_affiliate_btn"
                onClick={() => setShowAffiliateChartModal(true)}
              >
                About affiliate
              </button>
            )}
            <h1 className="auth_heading">
              {isAffiliateFlow ? "Join the Importerr Affiliate Program" : content.upsaleoHeading}
              <br />
              {isAffiliateFlow ? "Earn with every referral" : content.upsaleoSubHeading}
            </h1>
            <ErrorModal
              isOpen={errorModal.isOpen}
              onClose={closeErrorModal}
              message={errorModal.message}
            />
            <img src={SignUpImage} className="auth_image" alt="Signup" />
            
            {/* Follow us on section - desktop version (hidden on mobile and iPad) */}
            <div className="follow_us_desktop">
              <FollowUsSection />
            </div>
            
            {/* Follow us on section - iPad version (visible only on iPad) */}
            <div className="follow_us_ipad">
              <FollowUsSection />
            </div>
          </div>

          <div className="auth_col_two signup_auth_col_two">
            <div className="signup_right_wrap">
            <form className={`auth_form ${isAffiliateFlow ? "affiliate-signup-auth-form" : ""}`} onSubmit={handleSignup}>
              <h1>{isAffiliateFlow ? (emailOtpUI.verified ? "Complete your details" : "Let's begin!") : content.mainHeading}</h1>

              {/* Affiliate flow: step 1 – only email + OTP until verified */}
              {(isAffiliateFlow && !emailOtpUI.verified) ? (
                <>
                  <div className="email_row">
                    <div className="email_left">
                      <div className={`float_group ${error.email || error.emailOtp ? "has-error" : ""}`}>
                        <WebInput
                          parentClassName="input_parent"
                          className="signup_input"
                          id="emailInput"
                          type="email"
                          placeholder=" "
                          name="email"
                          value={data.email}
                          error={error.email}
                          onChange={(e) => {
                            setEmailOtpUI({ sent: false, verified: false, timerOn: false, seconds: 60 });
                            setEmailOtp("");
                            resetErrors("emailOtp");
                            handleOnchange(e);
                          }}
                        />
                        <label htmlFor="emailInput" className="float_label">Email ID</label>
                      </div>
                    </div>
                    <div className="email_right">
                      {emailOtpUI.verified ? (
                        <span className="verified_pill">✓ Verified</span>
                      ) : !emailOtpUI.timerOn ? (
                        <WebButton
                          className="otp_btn"
                          text={isSendingEmailOtp ? "Sending..." : (emailOtpUI.sent ? "Resend OTP" : "Send OTP")}
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isSendingEmailOtp) requestEmailOtp();
                          }}
                          disabled={isSendingEmailOtp}
                        />
                      ) : (
                        <span className="timer">00:{emailOtpUI.seconds > 9 ? emailOtpUI.seconds : `0${emailOtpUI.seconds}`}</span>
                      )}
                    </div>
                  </div>
                  {emailOtpUI.sent && !emailOtpUI.verified && (
                    <div className="otp_verified_container">
                      <div className="otp_left">
                        <WebOtpInput setOtpVal={setEmailOtp} length={6} />
                        {error.emailOtp ? <span className="otp_error">{error.emailOtp}</span> : null}
                      </div>
                      <WebButton
                        className={`otp_verify_btn ${isVerifyingEmailOtp ? "_verifying" : ""}`}
                        text={isVerifyingEmailOtp ? "Verifying..." : "Verify"}
                        onClick={(e) => { e.preventDefault(); if (!isVerifyingEmailOtp) verifyEmailOtp(); }}
                        disabled={isVerifyingEmailOtp || emailOtp.length !== 6}
                      />
                    </div>
                  )}
                  <div className="auth_message" onClick={() => navigate("/login")}>
                    <p></p>
                    <p>Sign in to an existing account</p>
                  </div>
                </>
              ) : (
              <>
              {isAffiliateFlow && fetchingProfileForAffiliate ? (
                <div className="auth_message" style={{ marginBottom: "1rem", color: "var(--primary)", fontWeight: 500 }}>
                  Fetching data from your account…
                </div>
              ) : (
              <>
              <div className="name_row">
                <div className="name_col">
                  <div className={`float_group ${error.firstName ? "has-error" : ""}`}>
                    <WebInput
                      parentClassName="input_parent"
                      className="signup_input"
                      id="firstNameInput"
                      type="text"
                      placeholder=" "
                      name="firstName"
                      value={data.firstName}
                      error={error.firstName}
                      onChange={handleOnchange}
                    />
                    <label htmlFor="firstNameInput" className="float_label">First Name</label>
                  </div>
                </div>

                <div className="name_col">
                  <div className={`float_group ${error.lastName ? "has-error" : ""}`}>
                    <WebInput
                      parentClassName="input_parent"
                      className="signup_input"
                      id="lastNameInput"
                      type="text"
                      placeholder=" "
                      name="lastName"
                      value={data.lastName}
                      error={error.lastName}
                      onChange={handleOnchange}
                    />
                    <label htmlFor="lastNameInput" className="float_label">Last Name</label>
                  </div>
                </div>
              </div>

              {(!isAffiliateFlow || existingUserForAffiliate) && (
              <>
              <div className="email_row">
                <div className="email_left">
                  <div className={`float_group ${error.phone || error.phoneOtp ? "has-error" : ""}`}>
                    <WebInput
                      parentClassName="input_parent"
                      className="signup_input"
                      id="phoneInput"
                      type="text"
                      placeholder=" "
                      name="phone"
                      value={data.phone}
                      error={error.phone}
                      onChange={handlePhone}
                      maxLength="10"
                      readOnly={phoneOtpUI.verified}
                      style={phoneOtpUI.verified ? { backgroundColor: "#f0f9ff", cursor: "not-allowed" } : {}}
                    />
                    <label htmlFor="phoneInput" className="float_label">Contact Number</label>
                  </div>
                </div>
                <div className="email_right">
                  {phoneOtpUI.verified ? (
                    <span className="verified_pill">✓ Verified</span>
                  ) : !phoneOtpUI.timerOn ? (
                    <WebButton
                      className="otp_btn"
                      text={isSendingPhoneOtp ? "Sending..." : (phoneOtpUI.sent ? "Resend OTP" : "Send OTP")}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isSendingPhoneOtp) requestPhoneOtp();
                      }}
                      disabled={isSendingPhoneOtp}
                    />
                  ) : (
                    <span className="timer">00:{phoneOtpUI.seconds > 9 ? phoneOtpUI.seconds : `0${phoneOtpUI.seconds}`}</span>
                  )}
                </div>
              </div>

              {phoneOtpUI.sent && !phoneOtpUI.verified && (
                <div className="otp_verified_container">
                  <div className="otp_left">
                    <WebOtpInput setOtpVal={setPhoneOtp} length={6} />
                    {error.phoneOtp ? <span className="otp_error">{error.phoneOtp}</span> : null}
                  </div>
                  <WebButton
                    className={`otp_verify_btn ${isVerifyingPhoneOtp ? "_verifying" : ""}`}
                    text={isVerifyingPhoneOtp ? "Verifying..." : "Verify"}
                    onClick={(e) => { e.preventDefault(); if (!isVerifyingPhoneOtp) verifyPhoneOtpHandler(); }}
                    disabled={isVerifyingPhoneOtp || phoneOtp.length !== 6}
                  />
                </div>
              )}
              </>
              )}

              {/* EMAIL + OTP (only when not in affiliate step-1) */}
              {(!isAffiliateFlow || emailOtpUI.verified) && (
              <>
              <div className="email_row">
                <div className="email_left">
                  <div className={`float_group ${error.email || error.emailOtp ? "has-error" : ""}`}>
                    <WebInput
                      parentClassName="input_parent"
                      className="signup_input"
                      id="emailInput"
                      type="email"
                      placeholder=" "
                      name="email"
                      value={data.email}
                      error={error.email}
                      onChange={(e) => {
                        setEmailOtpUI({ sent: false, verified: false, timerOn: false, seconds: 60 });
                        setEmailOtp("");
                        resetErrors("emailOtp");
                        handleOnchange(e);
                      }}
                      readOnly={isAffiliateFlow && emailOtpUI.verified}
                      style={isAffiliateFlow && emailOtpUI.verified ? { backgroundColor: "#f0f9ff", cursor: "not-allowed" } : {}}
                    />
                    <label htmlFor="emailInput" className="float_label">Email ID</label>
                  </div>
                </div>

                <div className="email_right">
                  {emailOtpUI.verified ? (
                    <span className="verified_pill">✓ Verified</span>
                  ) : !emailOtpUI.timerOn ? (
                    <WebButton
                      className="otp_btn"
                      text={isSendingEmailOtp ? "Sending..." : (emailOtpUI.sent ? "Resend OTP" : "Send OTP")}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isSendingEmailOtp) requestEmailOtp();
                      }}
                      disabled={isSendingEmailOtp}
                    />
                  ) : (
                    <span className="timer">00:{emailOtpUI.seconds > 9 ? emailOtpUI.seconds : `0${emailOtpUI.seconds}`}</span>
                  )}
                </div>
              </div>

              {emailOtpUI.sent && !emailOtpUI.verified && (
                <div className="otp_verified_container">
                  <div className="otp_left">
                    <WebOtpInput setOtpVal={setEmailOtp} length={6} />
                    {error.emailOtp ? <span className="otp_error">{error.emailOtp}</span> : null}
                  </div>
                  <WebButton
                    className={`otp_verify_btn ${isVerifyingEmailOtp ? "_verifying" : ""}`}
                    text={isVerifyingEmailOtp ? "Verifying..." : "Verify"}
                    onClick={(e) => { e.preventDefault(); if (!isVerifyingEmailOtp) verifyEmailOtp(); }}
                    disabled={isVerifyingEmailOtp || emailOtp.length !== 6}
                  />
                </div>
              )}
              </>
              )}


              {/* SALES CHANNELS (hidden in affiliate flow) */}
              {!isAffiliateFlow && (
              <div className="sales_channel_group">
                <div className={`input_parent float_group ${data.marketPlaces.length ? "has-value" : ""}`}>
                  <button
                    type="button"
                    className="sales_control signup_input"
                    onClick={() => setSalesOpen((p) => !p)}
                  >
                    {data.marketPlaces.length
                      ? `${data.marketPlaces.length} selected`
                      : ""}
                    <span className="caret" aria-hidden>▾</span>
                  </button>
                  <label className="float_label">Select sales channels</label>

                  {salesOpen && (
                    <div className="sales_menu">
                      <input
                        className="sales_search"
                        placeholder="Search"
                        value={salesQuery}
                        onChange={(e) => setSalesQuery(e.target.value)}
                      />
                      <div className="sales_list">
                        {filteredSales.map((opt) => {
                          const checked = data.marketPlaces.includes(opt);
                          return (
                            <label key={opt} className="sales_item">
                              <input
                                type="checkbox"
                                checked={checked}
                                onChange={() => toggleSales(opt)}
                              />
                              <span>{opt}</span>
                            </label>
                          );
                        })}
                      </div>
                      <div className="sales_actions">
                        <button
                          type="button"
                          className="sales_clear_btn"
                          onClick={() => {
                            setData((p) => ({ ...p, marketPlaces: [] }));
                          }}
                        >
                          Clear
                        </button>
                        <button
                          type="button"
                          className="sales_done_btn"
                          onClick={() => setSalesOpen(false)}
                        >
                          Done
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {error.marketPlaces ? (
                  <span className="terms-error">{error.marketPlaces}</span>
                ) : null}
              </div>
              )}

              {!existingUserForAffiliate && (
              <div className="password_row">
              <div className={`float_group ${error.password ? "has-error" : ""} password_group`}>
                <WebInput
                  parentClassName="input_parent"
                  className="signup_input"
                  id="passwordInput"
                  type={showPassword ? "text" : "password"}
                  placeholder=" "
                  name="password"
                  value={data.password}
                  error={error.password}
                  onChange={handleOnchange}
                />
                <label htmlFor="passwordInput" className="float_label">New Password</label>

                <button
                  type="button"
                  className="eye_btn"
                  onClick={() => setShowPassword(p => !p)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </button>
              </div>


              <div className={`float_group ${error.confirmPassword ? "has-error" : ""} password_group`}>
                <WebInput
                  parentClassName="input_parent"
                  className="signup_input"
                  id="confirmPasswordInput"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder=" "
                  name="confirmPassword"
                  value={data.confirmPassword}
                  error={error.confirmPassword}
                  onChange={handleOnchange}
                />
                <label htmlFor="confirmPasswordInput" className="float_label">Confirm Password</label>

                <button
                  type="button"
                  className="eye_btn"
                  onClick={() => setShowConfirmPassword(p => !p)}
                  aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                >
                  {showConfirmPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </button>
              </div>

              </div>
              )}


              {/* OPTIONALS */}

              {/* GST (optional); always available on signup including affiliate flow */}
              <>
              <div className={`float_group ${error.gst ? "has-error" : ""}`}>
                <WebInput
                  parentClassName="input_parent"
                  className="signup_input"
                  id="gstInput"
                  type="text"
                  placeholder=" "
                  name="gst"
                  value={data.gst}
                  error={error.gst}
                  onChange={handleOnchange}
                  maxLength="15"
                />
                <label htmlFor="gstInput" className="float_label">GST Number (optional)</label>
              </div>

              {/* COMPANY NAME when GST has value */}
              {data.gst ? (
                <div className={`float_group ${error.companyName ? "has-error" : ""}`}>
                  <WebInput
                    parentClassName="input_parent"
                    className="signup_input"
                    id="companyNameInput"
                    type="text"
                    placeholder=" "
                    name="companyName"
                    value={data.companyName}
                    error={error.companyName}
                    onChange={handleOnchange}
                  />
                  <label htmlFor="companyNameInput" className="float_label">Company Name</label>
                </div>
              ) : null}
              </>
              {!isAffiliateFlow && (
              <div className="float_group">
                <WebInput
                  parentClassName="input_parent"
                  className={`signup_input ${refFromUrl ? 'affiliate-signup-referral-readonly' : ''}`}
                  id="referredByInput"
                  type="text"
                  placeholder=" "
                  name="referredBy"
                  value={data.referredBy}
                  onChange={handleOnchange}
                  readOnly={!!refFromUrl}
                  style={refFromUrl ? { backgroundColor: '#f0f9ff', cursor: 'not-allowed' } : {}}
                />
                <label htmlFor="referredByInput" className="float_label">
                  {refFromUrl ? `Referred By: ${refFromUrl}` : 'Referred By (optional)'}
                </label>
              </div>
              )}

              {/* Terms & Conditions – at bottom, clearer UI */}
              <div className="tnc_section">
                <div className="tnc_row">
                  <input
                    id="tnc"
                    type="checkbox"
                    name="acceptTnc"
                    checked={data.acceptTnc}
                    onChange={handleOnchange}
                  />
                  <label htmlFor="tnc">
                    I agree to the <a href="/terms-and-conditions" target="_blank" rel="noreferrer">Terms of Use</a> & <a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>.
                  </label>
                </div>
                {error.acceptTnc ? <span className="terms-error">{error.acceptTnc}</span> : null}
              </div>

              {existingUserForAffiliate ? (
                <WebButton
                  className="signup_auth_btn"
                  text="Become Affiliate"
                  onClick={(e) => { e.preventDefault(); handleBecomeAffiliateClick(e); }}
                />
              ) : (
              <WebButton
                className={`signup_auth_btn ${(!emailOtpUI.verified || (!isAffiliateFlow && !phoneOtpUI.verified) || isSubmitting) ? "disabled_btn" : ""}`}
                text={isSubmitting ? "Signing up..." : isAffiliateFlow ? "Sign Up as Affiliate" : "Sign Up"}
                onClick={(e) => { if (!isSubmitting) handleSignup(e); }}
                disabled={!emailOtpUI.verified || (!isAffiliateFlow && !phoneOtpUI.verified) || isSubmitting}
              />
              )}

              <div className="auth_message" onClick={() => navigate("/login")}>
                <p></p>
                <p>Sign in to an existing account</p>
              </div>

              {/* Follow us on section - mobile version (hidden on desktop and iPad) */}
              <div className="follow_us_mobile">
                <FollowUsSection />
              </div>
              </>
              )}
              </>
              )}
            </form>

            </div>
          </div>
        </div>
      </div>

      {showAffiliateChartModal && (
        <div className="affiliate-signup-chart-fullscreen-overlay" onClick={() => setShowAffiliateChartModal(false)}>
          <div className="affiliate-signup-chart-fullscreen-modal" onClick={(e) => e.stopPropagation()}>
            <div className="affiliate_chart_fullscreen_header">
              <h2 className="affiliate-signup-chart-fullscreen-title">Commission & Payout</h2>
              <button type="button" className="affiliate-signup-chart-fullscreen-close" onClick={() => setShowAffiliateChartModal(false)} aria-label="Close">×</button>
            </div>
            <div className="affiliate_chart_fullscreen_body">
              <div className="affiliate-signup-table-wrap affiliate-signup-main-table-wrap">
                <table className="affiliate_spreadsheet_table">
                  <thead>
                    <tr>
                      <th>Sale Target</th>
                      <th>Without GST Sale Amt</th>
                      <th>Commission %</th>
                      <th>Payout Amount</th>
                      <th>Total Number of sellers</th>
                      <th>Total Payout</th>
                      <th>Total GMV</th>
                      <th>Additional GMV Incentive (Without GST)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>236,000</td><td><strong>200,000</strong></td><td>2%</td><td>4,000</td><td>50</td><td>200,000</td><td>₹11,800,000</td><td>₹10,000,000</td></tr>
                    <tr><td>590,000</td><td><strong>500,000</strong></td><td>2.5%</td><td>12,500</td><td>50</td><td>625,000</td><td>₹29,500,000</td><td>₹25,000,000</td></tr>
                    <tr><td>1,180,000</td><td><strong>1,000,000</strong></td><td>3%</td><td>30,000</td><td>50</td><td>1,500,000</td><td>₹59,000,000</td><td>₹50,000,000</td></tr>
                    <tr><td>1,770,000</td><td><strong>1,500,000</strong></td><td>3.25%</td><td>48,750</td><td>50</td><td>2,437,500</td><td>₹88,500,000</td><td>₹75,000,000</td></tr>
                    <tr><td>2,360,000</td><td><strong>2,000,000</strong></td><td>3.25%</td><td>65,000</td><td>50</td><td>3,250,000</td><td>₹118,000,000</td><td>₹100,000,000</td></tr>
                  </tbody>
                </table>
              </div>
              <div className="affiliate-signup-registration-payout-section">
                <table className="affiliate_reg_table">
                  <thead>
                    <tr>
                      <th>Eligibility sales</th>
                      <th>Payout</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{affiliateProgramDisplay?.eligibleThreshold != null ? Number(affiliateProgramDisplay.eligibleThreshold).toLocaleString("en-IN") : "20,000"}</td>
                      <td>{affiliateProgramDisplay?.registrationBonus != null ? Number(affiliateProgramDisplay.registrationBonus).toLocaleString("en-IN") : "500"} <span className="affiliate-signup-reg-label">Registration Payout</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {showNetworkModal && (
        <div className="affiliate_network_overlay" onClick={() => !isSavingNetworks && setShowNetworkModal(false)}>
          <div className="affiliate-signup-network-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Add your social networks (optional)</h3>
            <div className="affiliate_network_fields">
              <div className="float_group">
                <WebInput
                  parentClassName="input_parent"
                  className="signup_input"
                  type="url"
                  placeholder=" "
                  value={affiliateNetworks.facebook}
                  onChange={(e) => setAffiliateNetworks((p) => ({ ...p, facebook: e.target.value }))}
                />
                <label className="float_label">Facebook URL</label>
              </div>
              <div className="float_group">
                <WebInput
                  parentClassName="input_parent"
                  className="signup_input"
                  type="url"
                  placeholder=" "
                  value={affiliateNetworks.instagram}
                  onChange={(e) => setAffiliateNetworks((p) => ({ ...p, instagram: e.target.value }))}
                />
                <label className="float_label">Instagram URL</label>
              </div>
              <div className="float_group">
                <WebInput
                  parentClassName="input_parent"
                  className="signup_input"
                  type="url"
                  placeholder=" "
                  value={affiliateNetworks.youtube}
                  onChange={(e) => setAffiliateNetworks((p) => ({ ...p, youtube: e.target.value }))}
                />
                <label className="float_label">YouTube URL</label>
              </div>
            </div>
            <div className="affiliate-signup-network-actions">
              <WebButton
                className="signup_auth_btn"
                text={isSavingNetworks ? "Please wait..." : "Skip & Continue"}
                disabled={isSavingNetworks}
                onClick={async () => {
                  if (existingUserForAffiliate) {
                    setIsSavingNetworks(true);
                    try {
                      const res = await AuthApiService.becomeAffiliate(
                        JSON.stringify({
                          email: data.email ? data.email.toLowerCase().trim() : data.email,
                          facebook: affiliateNetworks.facebook || "",
                          instagram: affiliateNetworks.instagram || "",
                          youtube: affiliateNetworks.youtube || "",
                        })
                      );
                      setIsSavingNetworks(false);
                      if (res.status?.code === 200) {
                        setShowNetworkModal(false);
                        const redirectPath = "/seller/affiliate/dashboard";
                        sessionStorage.setItem("postAuthRedirect", redirectPath);
                        message.showToast("You are now an affiliate. Please sign in.", ToastTypes.SUCCESS);
                        navigate("/login", { replace: true, state: { from: { pathname: redirectPath } } });
                      } else {
                        message.showToast(res.error?.message || "Something went wrong", ToastTypes.ERROR);
                      }
                    } catch (err) {
                      setIsSavingNetworks(false);
                      message.showToast(err?.message || "Failed to become affiliate", ToastTypes.ERROR);
                    }
                  } else {
                    setShowNetworkModal(false);
                    navigate("/seller/affiliate/dashboard", { replace: true });
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}